import React, { Component } from "react"
import { connect } from 'react-redux'
import { saveTransactionAction} from '../../redux/actions/MainAction'
import moment from 'moment'
import { Input, DatePicker, Select, DropDownList } from "../core";
import $ from 'jquery'
import utilityHelper from '../../helpers/helperUtil'

import {
    updateIR_OneTimeVendorAction,
    updateIR_OneTimeVendorModalAction
} from '../../redux/actions/IRAction'

import {msg} from '../../components/Notifications/MsgBox';
import {
    data_t_IR_ONE_TIME_VENDOR
} from '../../configs/datas'

class OneTimeVendorModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
            vendor_code:null,
            vendor_name:null
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.getBankBranch = this.getBankBranch.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.oneTimeVendorModal !== nextProps.t_IR_ONE_TIME_VENDOR) {
            this.setState({
                oneTimeVendorModal: nextProps.t_IR_ONE_TIME_VENDOR,
                vendor_name: nextProps.t_PO_DETAIL.vendor_name,
                vendor_code: nextProps.t_PO_DETAIL.vendor_code
            })
        }
    }


    getBankBranch(bankName){

        let result = null
        const { bankBranchs } = this.props
        result = bankBranchs.filter(f => f.key1.match(bankName))
        if (result) {
            result = utilityHelper.toSelectList(result, "display", "value")
        }

         console.log(result)

        return result
    }

    handleSave(){
        if(this.state.oneTimeVendorModal.ot_tax_number3 === null || this.state.oneTimeVendorModal.ot_tax_number3 === ""){
            msg.error("กรุณาระบุ เลขที่ประจำตัวผู้เสียภาษี")
        }else if(this.state.oneTimeVendorModal.ot_pcode && this.state.oneTimeVendorModal.ot_pcode.length > 0 && this.state.oneTimeVendorModal.ot_pcode.length !== 5){
            msg.error("PCode ต้องมีจำนวน 5 digit")
        }else if(this.state.oneTimeVendorModal.ot_postal_code && this.state.oneTimeVendorModal.ot_postal_code.length > 0 && this.state.oneTimeVendorModal.ot_postal_code.length !== 5){
            msg.error("รหัสไปรษณีย์ ต้องมีจำนวน 5 digit")
        }else{
                this.props.updateIR_OneTimeVendorModal(this.state.oneTimeVendorModal)
                window.$('#oneTimeVendorModal').modal('hide')
            }
    }

    handleClose(){
        this.setState({
            oneTimeVendorModal: {
                ...this.props.t_IR_ONE_TIME_VENDOR,
            }
        })
        window.$('#oneTimeVendorModal').modal('hide')
    }
    

    async handleChange(event) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        // if ((value.toString()).indexOf("/") > 0) {
        //     if (moment(value, 'DD/MM/YYYY').isValid()) {
        //         value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
        //     }
        // }

        if (valid) {
            await this.setState({
                oneTimeVendorModal: {
                    ...this.state.oneTimeVendorModal,
                    [name]: value
                }
            });
        } else {
            return
        }

    }

    render() {
        console.log("OneTimeVendorModal.render")
        console.log(this.props.oneTimeVendorModal)
        const {t_PO_DETAIL,viewMode} = this.props
        var invalid = /[°"§%()\[\]{}=\\?´`'#<>|,;.:+_-]+/g;
        let _bankname = ""; //this.state.oneTimeVendorModal.ot_bank_name && this.state.oneTimeVendorModal.ot_bank_name.replace(invalid, "");
        var re = new RegExp(_bankname, 'g');
        
        return (
            <div className="modal fade sp-modal rrs-modal" id="oneTimeVendorModal" tabIndex={-1} role="dialog" aria-labelledby="oneTimeVendorModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="oneTimeVendorModalLabel">One Time Vendor</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="rrs-detail-data sp-table-container">
                                <div className="row align-items-center mx-0 mb-4">
                                    <div className="col-md-12 col-lg-12 pr-md-12 pl-0">
                                        Purchase Order PO / Contract Number : {t_PO_DETAIL ? t_PO_DETAIL.po_contract_no : ""}
                                    </div>
                                </div>
                                <div className="row align-items-center mx-0">
                                    <div className="col-md-12">
                                        <div className="rrs-form">
                                            <div className="row">
                                            <label htmlFor="account_assignment" className="rrs-label col-md-4">รหัส Vendor :</label>
                                            <label htmlFor="account_assignment" className="rrs-label col-md-8">ชื่อ Vendor :</label>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-4">
                                                        <input className="form-control-gray" 
                                                            disabled={true}
                                                            type="text"
                                                            name="vendor_code"
                                                            value={this.state.vendor_code || ''}
                                                            className="form-control vendor_code"
                                                            id="vendor_code"
                                                            onChange={this.handleChange}
                                                            // disabled={viewMode}
                                                        />
                                                </div>
                                                <div className="col-sm-8">
                                                        <input 
                                                            disabled={true}
                                                            type="text"
                                                            name="vendor_name"
                                                            value={this.state.vendor_name || ''}
                                                            className="form-control vendor_name"
                                                            id="vendor_name"
                                                            onChange={this.handleChange}
                                                            // disabled={viewMode}
                                                        />
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                            <label htmlFor="account_assignment" className="rrs-label col-sm-6">ชื่อเรื่อง :</label>
                                            <label htmlFor="account_assignment" className="rrs-label col-sm-6"><span className="required">*</span> เลขที่ประจำตัวผู้เสียภาษี :</label>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                        <input
                                                            type="text"
                                                            name="ot_title"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_title || '' : ''}
                                                            className="form-control ot_title"
                                                            id="ot_title"
                                                            onChange={this.handleChange}
                                                            disabled={viewMode}
                                                            maxLength="15"
                                                        />
                                                </div>
                                                <div className="col-sm-6">
                                                        <input
                                                            type="text"
                                                            name="ot_tax_number3"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_tax_number3 || '' : ''}
                                                            className="form-control ot_tax_number3"
                                                            id="ot_tax_number3"
                                                            onChange={this.handleChange}
                                                            maxLength="18"
                                                            disabled={viewMode}
                
                                                        />
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                            <label htmlFor="account_assignment" className="rrs-label col-md-12">ชื่อ :</label>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 mb-2">
                                                        <input
                                                            type="text"
                                                            name="ot_name1"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_name1 || '' : ''}
                                                            className="form-control ot_name1"
                                                            id="ot_name1"
                                                            onChange={this.handleChange}
                                                            maxLength="35"
                                                            disabled={viewMode}
                                                        />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 mb-2">
                                                        <input
                                                            type="text"
                                                            name="ot_name2"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_name2 || '' : ''}
                                                            className="form-control ot_name2"
                                                            id="ot_name2"
                                                            onChange={this.handleChange}
                                                            maxLength="35"
                                                            disabled={viewMode}
                                                        />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 mb-2">
                                                        <input
                                                            type="text"
                                                            name="ot_name3"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_name3 || '' : ''}
                                                            className="form-control ot_name3"
                                                            id="ot_name3"
                                                            onChange={this.handleChange}
                                                            maxLength="35"
                                                            disabled={viewMode}
                                                        />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 mb-2">
                                                        <input
                                                            type="text"
                                                            name="ot_name4"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_name4 || '' : ''}
                                                            className="form-control ot_name4"
                                                            id="ot_name4"
                                                            onChange={this.handleChange}
                                                            maxLength="35"
                                                            disabled={viewMode}
                                                        />
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                            <label htmlFor="account_assignment" className="rrs-label col-sm-6">ถนน :</label>
                                            <label htmlFor="account_assignment" className="rrs-label col-sm-6">PCode :</label>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                        <input
                                                            type="text"
                                                            name="ot_street"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_street || ''  : ''}
                                                            className="form-control ot_street"
                                                            id="ot_street"
                                                            onChange={this.handleChange}
                                                            disabled={viewMode}
                                                            maxLength="35"
                                                        />
                                                </div>
                                                <div className="col-sm-6">
                                                        <input
                                                            type="text"
                                                            name="ot_pcode"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_pcode || '' : ''}
                                                            className="form-control ot_pcode"
                                                            id="ot_pcode"
                                                            onChange={this.handleChange}
                                                            pattern="[0-9]*"
                                                            maxLength="5"
                                                            disabled={viewMode}
                                                        />
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                            <label htmlFor="account_assignment" className="rrs-label col-sm-6">PO Box :</label>
                                            <label htmlFor="account_assignment" className="rrs-label col-sm-6">รหัสไปรษณีย์ :</label>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                        <input
                                                            type="text"
                                                            name="ot_po_box"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_po_box || '' : ''}
                                                            className="form-control ot_po_box"
                                                            id="ot_po_box"
                                                            onChange={this.handleChange}
                                                            maxLength="5"
                                                            disabled={viewMode}
                                                        />
                                                </div>
                                                <div className="col-sm-6">
                                                        <input
                                                            type="text"
                                                            name="ot_postal_code"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_postal_code || '' : ''}
                                                            className="form-control ot_postal_code"
                                                            id="ot_postal_code"
                                                            onChange={this.handleChange}
                                                            pattern="[0-9]*"
                                                            maxLength="5"
                                                            disabled={viewMode}
                                                        />
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                            <label htmlFor="account_assignment" className="rrs-label col-sm-6">เมือง :</label>
                                            <label htmlFor="account_assignment" className="rrs-label col-sm-6">รหัสภูมิภาค :</label>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <input
                                                        type="text"
                                                        name="ot_city"
                                                        value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_city || '' : ''}
                                                        className="form-control ot_city"
                                                        id="ot_city"
                                                        onChange={this.handleChange}
                                                        maxLength="35"
                                                        disabled={viewMode}
                                                    />
                                                </div>
                                                <div className="col-sm-6">
                                                        <select
                                                            className="form-control ot_region"
                                                            name="ot_region"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_region || '' : ''}
                                                            onChange={this.handleChange}
                                                            disabled={viewMode}
                                                        >
                                                        <option>-- เลือก --</option> 
                                                            {this.props.regions && this.props.regions.map((datas, index) => (
                                                                datas.key === "Region" && (
                                                                    <option
                                                                        key={index}
                                                                        value={datas.value}>
                                                                        {datas.value+" "+datas.display}
                                                                    </option>
                                                                )
                                                            ))}
                                                        </select>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                            <label htmlFor="account_assignment" className="rrs-label col-sm-6">ประเทศ :</label>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                        <select
                                                            className="form-control ot_country"
                                                            name="ot_country"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_country || '' : ''}
                                                            onChange={this.handleChange}
                                                            disabled={viewMode}
                                                        >
                                                            {this.props.countries && this.props.countries.map((datas, index) => (
                                                                datas.key === "Country" && (
                                                                    <option
                                                                        key={index}
                                                                        value={datas.value}>
                                                                        {datas.display}
                                                                    </option>
                                                                )
                                                            ))}
                                                        </select>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                            <label htmlFor="account_assignment" className="rrs-label col-sm-6">ชื่อธนาคาร :</label>
                                            <label htmlFor="account_assignment" className="rrs-label col-sm-6">สาขาธนาคาร :</label>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                        <select
                                                            className="form-control ot_bank_name"
                                                            name="ot_bank_name"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_bank_name || '' : ''}
                                                            onChange={this.handleChange}
                                                            disabled={viewMode}
                                                        >
                                                        <option>-- เลือก --</option>  
                                                            {this.props.bankNames && this.props.bankNames.map((datas, index) => (
                                                                datas.key === "BankName" && (
                                                                    <option
                                                                        key={index}
                                                                        value={datas.value}>
                                                                        {datas.display}
                                                                    </option>
                                                                )
                                                            ))}                                                        
                                                        </select>
                                                </div>
                                                <div className="col-sm-6">
                                                    
                                                    {/* <DropDownList
                                                        name="ot_bank_branch"
                                                        options={this.getBankBranch(re)}
                                                        onSelectChanged={this.handleChange}
                                                         selected={this.state.oneTimeVendorModal.ot_bank_branch}
                                                        doctype={"*"}
                                                    >
                                                    </DropDownList> */}

                                                    
                                                        <select
                                                            className="form-control ot_bank_branch"
                                                            name="ot_bank_branch"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_bank_branch || '' : ''}
                                                            onChange={this.handleChange}
                                                            disabled={viewMode}
                                                        >                    
                                                        <option>-- เลือก --</option>                                        
                                                            {this.props.bankBranchs && this.props.bankBranchs.map((datas, index) => (
                                                                datas.key === "BankBranch" && datas.key1.match(re) && (
                                                                    <option
                                                                        key={index}
                                                                        value={datas.value}>
                                                                        {datas.display}
                                                                    </option>
                                                                )
                                                            ))}
                                                        </select>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                            <label htmlFor="account_assignment" className="rrs-label col-sm-6">เลขที่บัญชีธนาคาร :</label>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                        <input
                                                            type="text"
                                                            name="ot_bank_account"
                                                            value={this.state.oneTimeVendorModal?this.state.oneTimeVendorModal.ot_bank_account || '' : ''}
                                                            className="form-control ot_bank_account"
                                                            id="ot_bank_account"
                                                            onChange={this.handleChange}
                                                            maxLength="18"
                                                            disabled={viewMode}
                                                        />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="rrs-detail py-1">
                                <div className="row sp-table-content-footer">
                                    <div className="col-12 sp-header-button-panel2">
                                        
                                        <React.Fragment>
                                            <a href="#main" className="sp-btn-icon btn-del" onClick={() => this.handleClose()}>
                                                <i className="icon btn-order-delete" />
                                                <span className="sp-btn-icon-label">Close</span>
                                            </a>
                                            <a href="#main" onClick={() => this.handleSave()} style={{ visibility: viewMode ? "hidden" : "visible" }} className="sp-btn-icon" >
                                                <i className="icon btn-order-savedraft" />
                                                <span className="sp-btn-icon-label">Save</span>
                                            </a>
                                        </React.Fragment>                                        

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
      
    }
}

const mapStateToProps = state => {
    const { MainRedux, MasterRedux} = state
    return {
        //transaction: MainRedux.transaction,
        t_PO_DETAIL:MainRedux.t_PO_DETAIL,
        t_IR_ONE_TIME_VENDOR:MainRedux.t_IR_ONE_TIME_VENDOR,
        regions: MasterRedux.regions,
        countries: MasterRedux.countries,
        bankBranchs: MasterRedux.bankBranchs,
        bankNames: MasterRedux.bankNames,
        oneTimeVendorModal: MainRedux.oneTimeVendorModal,
        viewMode: MainRedux.viewMode,
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
        updateIR_OneTimeVendor: () => dispatch(updateIR_OneTimeVendorAction()),
        updateIR_OneTimeVendorModal: (data) => dispatch(updateIR_OneTimeVendorModalAction(data)),
        saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction))
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(OneTimeVendorModal)